import type { SparkyContextKind } from './types'

export interface SparkyContextCopy {
  /** Text after "Context: " in the header chip. */
  chip: string
  /** Header line: what Sparky looks at here. */
  description: string
  /** Empty-chat line: what Sparky knows. */
  sees: string
  placeholder: string
  /** Clickable example questions for the empty chat; a click sends the text. */
  suggestions: readonly string[]
}

const DEAL_SUGGESTIONS = [
  'Vat dit dossier samen',
  'Welke vragen staan nog open voor de founder?',
  'Wat ontbreekt nog voor IC?',
] as const

const BOARD_SUGGESTIONS = [
  'Welke deals staan te lang in hun fase?',
  'Wat is er deze week veranderd?',
  'Welke deals hebben geen volgende stap?',
] as const

const OTHER_SUGGESTIONS = [
  'Welke deals staan te lang in hun fase?',
  'Welke deals hebben geen volgende stap?',
  'Wil je een samenvatting van een dossier?',
] as const

const BOARD_ROUTES = new Set(['/preinvest', '/preinvest/board'])

/**
 * spec-65 U-042: say what Sparky really sees. Only a pre-invest deal dossier
 * has its own context; everywhere else Sparky reads the active pre-invest
 * deals, and outside the board the header says so instead of promising "deze
 * pagina". `route` is null for an earlier conversation: its context was frozen
 * when it started, so the copy describes that conversation, not the page.
 */
export function sparkyContextCopy(kind: SparkyContextKind, route: string | null): SparkyContextCopy {
  if (kind === 'deal') {
    return {
      chip: 'dealdossier',
      description:
        route === null ? 'Dit gesprek gaat over een dealdossier.' : 'Sparky kijkt mee met dit dealdossier.',
      sees: 'Sparky kent het dossier van deze deal: documenten, notities, journey en mail.',
      placeholder: 'Stel een vraag over deze deal…',
      suggestions: DEAL_SUGGESTIONS,
    }
  }
  const description =
    route === null
      ? 'Dit gesprek gaat over het dealbord.'
      : BOARD_ROUTES.has(route)
        ? 'Sparky kijkt mee met het dealbord.'
        : 'Sparky kent deze pagina nog niet; hij ziet de actieve pre-invest-deals.'
  return {
    chip: 'Dealbord (actieve deals)',
    description,
    sees: 'Sparky ziet de actieve deals met hun fase en laatste update.',
    placeholder: 'Stel een vraag over je actieve deals…',
    suggestions: route !== null && !BOARD_ROUTES.has(route) ? OTHER_SUGGESTIONS : BOARD_SUGGESTIONS,
  }
}
